import SelectCardModalContent from "../components/selectCardModalContent";
import { useBottomSheet } from "../context/BottomSheetContext";

export const useCryptidSelectModal = () => {
  const { openSheet,closeSheet } = useBottomSheet();

  const openCryptidSelectModal = (cryptids, onSelect, multipleSelection, selectedCards, limit) => {
    openSheet({content:<SelectCardModalContent  {...{cryptids,limit,multipleSelection,onSelect,selectedCards}} />,title:"Select Card"})
 }
const closeCryptidSelectModal = () => {
    closeSheet();
}


  return { openCryptidSelectModal ,closeCryptidSelectModal};
}
